<template>
  <form class="bank-withdraw-page" :class="{ 'bank-withdraw-page--dark': $vuetify.theme.dark }" @submit.prevent="handleSubmit">
    <v-container fluid class="main-container responsive-height bank-withdraw-container">
      <header class="bank-withdraw-heading"><span><v-icon>mdi-bank-transfer-out</v-icon></span><div><h1>Bank Withdraw</h1><p>Withdraw funds securely to your registered bank account.</p></div></header>
      <v-row>
        <v-col xl="6" lg="7" md="7" sm="7" cols="12">
          <v-card class="deposit-form bank-withdraw-form-card">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transfer Method</legend>
                  <v-text-field label="Bank Transfer" disabled placeholder="Bank Transfer" single-line solo hide-details
                    readonly class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Withdraw From</legend>
                  <v-select v-model="selectedAccount" :items="formattedAccounts" item-text="display"
                    item-value="trading_account_no" solo append-icon="mdi-chevron-down" label="Select One"
                    class="custom-select" hide-details @change="handleAccountChange"
                    :rules="[(v) => !!v || 'Account is required']" :error="errors.account"
                    :error-messages="errors.account ? ['Account is required'] : []">
                  </v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12"
                v-if="selectedAccountDetails && Number(selectedAccountDetails.trader_type) === 2">
                <fieldset>
                  <legend>Investor Available Withdraw Amount</legend>
                  <v-text-field
                    :value="`${selectedAccountDetails.currency_symbol || '$'} ${selectedAccountDetails.availableWithdraw} ( MAM Profit Amount is ${selectedAccountDetails.profitAmount}$ )`"
                    readonly solo hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Bank Name</legend>
                  <v-select v-model="selectedBank" :items="banks" item-text="bank_name" item-value="id" solo
                    append-icon="mdi-chevron-down" label="Select One" class="custom-select" hide-details
                    @change="handleBankChange" :rules="[(v) => !!v || 'Bank is required']" :error="errors.bank"
                    :error-messages="errors.bank ? ['Bank is required'] : []">
                  </v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Bank Account No.</legend>
                  <v-text-field v-model="bankAccountNumber" label="Bank Account Number" single-line solo hide-details
                    readonly class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Account Name</legend>
                  <v-text-field v-model="bankAccountName" label="Bank Account Name" single-line solo hide-details
                    readonly class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>IFSC Code</legend>
                  <v-text-field v-model="bankSwiftNum" label="$" single-line solo hide-details readonly
                    class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Bank Country</legend>
                  <v-text-field v-model="bankCountry" label="$" single-line solo hide-details readonly
                    class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Bank City</legend>
                  <v-text-field v-model="bankCity" label="$" single-line solo hide-details readonly
                    class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Bank Address</legend>
                  <v-text-field v-model="bankAddress" label="Write Here" single-line solo hide-details readonly
                    class="custom-select">
                  </v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" :md="currency.name !== 'USD' ? 6 : 12">
                <fieldset>
                  <legend>Amount in (USD) <small v-if="minTransactionUSD > 0" class="ms-2 text-muted">
                      (Min: ${{ minTransactionUSD }})
                    </small></legend>
                  <v-text-field v-model="withdrawAmount" label="$" type="number" single-line solo hide-details
                    class="custom-select" min="1" :rules="amountRules" :error="errors.amount"
                    :error-messages="errors.amount ? ['Amount is required'] : []"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6" v-if="currency.name !== 'USD'">
                <fieldset>
                  <legend>Amount in <span :style="{ color: currency.color }">({{ currency.name }})</span></legend>
                  <v-text-field readonly v-model="currencyAmount" :label="currency.symbol" type="number" single-line
                    solo hide-details class="custom-select text-muted"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-btn tile elevation="0" :loading="loading" :disabled="!isFormValid || loading"
                  class="ma-0 text-capitalize btn-account d-block bank-withdraw-button" type="submit">
                  Withdraw
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col xl="4" lg="4" md="5" sm="5" cols="12">
          <v-card v-if="selectedAccountDetails" class="elevation-0 deposit-form-card bank-withdraw-summary mt-2">
            <v-card-actions>
              <div class="trade-status">
                <div>
                  <v-icon>mdi-signal</v-icon>
                </div>
                <div class="trade-number">
                  <span>MT5 - {{ selectedAccountDetails.account_type_display }}</span>
                  <span>{{ selectedAccountDetails.trading_account_no }}</span>
                </div>
              </div>
            </v-card-actions>

            <v-card-actions>
              <div class="value-trades">
                <span>Balance</span>
                <span>{{ selectedAccountDetails.Balance }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="value-trades">
                <span>Currency</span>
                <span>{{ selectedAccountDetails.currency_name }}</span>
              </div>
            </v-card-actions>

            <v-card-actions>
              <v-sheet :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                <div>
                  <apexChart width="100%" height="95px" type="line" :options="options" :series="series" />
                </div>
              </v-sheet>
            </v-card-actions>

            <v-card-actions>
              <div class="currency-leverage">
                <span>Free Funds</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="currency-leverage">
                <span>Leverage</span>
                <span>{{ selectedAccountDetails.leverage }}:1</span>
              </div>
            </v-card-actions>

            <v-card-actions>
              <div class="balance-equity">
                <span>Free Margin</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="balance-equity">
                <span>Acc. Type</span>
                <span>{{ selectedAccountDetails.account_type_display }}</span>
              </div>
            </v-card-actions>

            <v-card-actions v-if="Number(selectedAccountDetails.trader_type) === 2" class="mt-4">
              <v-alert type="info" dense text class="w-100">
                This is an <strong>Investor Account</strong>. You can withdraw from your <strong>capital only</strong>.
                Your profit amount of <strong>{{ selectedAccountDetails.profitAmount }}</strong> will be processed by
                the MAM system.
              </v-alert>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { WITHDRAWMETHODS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      payment_id: null,

      // min withdraw amount in USD (from payment_settings.min_transaction)
      minTransactionUSD: 0,

      selectedAccount: null,
      selectedBank: null,
      bankAccountNumber: "",
      bankAccountName: "",
      bankSwiftNum: "",
      bankCountry: "",
      bankCity: "",
      bankAddress: "",
      withdrawAmount: "",
      currencyAmount: "",
      currency: {
        rate: 1,
        name: "USD",
        symbol: "$",
        color: "#ffc400",
      },
      loading: false,
      errors: {
        account: false,
        bank: false,
        amount: false,
      },
      options: {
        chart: {
          type: "line",
          toolbar: { show: false },
        },
        xaxis: {
          labels: { show: false },
          axisTicks: { show: false },
          axisBorder: { show: false },
        },
        yaxis: { labels: { show: false } },
        grid: { show: false },
        stroke: { width: 2 },
        dataLabels: { enabled: false },
        colors: ["#ffc400"],
      },
      series: [
        { name: "Series 1", data: [45, 52, 38, 45, 19, 23, 2] },
      ],

      // includes minTransactionUSD rule
      amountRules: [
        (v) => !!v || "Amount is required",
        (v) => parseFloat(v) > 0 || "Amount must be greater than 0",
        (v) =>
          !this.minTransactionUSD ||
          parseFloat(v) >= this.minTransactionUSD ||
          `Minimum withdrawal is $${this.minTransactionUSD}`,
        (v) =>
          !this.selectedAccountDetails ||
          parseFloat(v) <= this.selectedAccountDetails.MarginFree ||
          "Amount exceeds available funds",
      ],
    };
  },

  computed: {
    ...mapState("withdraw", ["methods", "accounts", "banks"]),

    formattedAccounts() {
      return this.accounts.map((account) => ({
        display: `${account.trading_account_no} (${account.account_type_display}) ${account.Balance} ${account.currency_name}`,
        trading_account_no: account.trading_account_no,
        ...account,
      }));
    },

    selectedAccountDetails() {
      return this.accounts.find(
        (acc) => acc.trading_account_no === this.selectedAccount
      );
    },

    isFormValid() {
      const amt = parseFloat(this.withdrawAmount);

      return (
        this.selectedAccount &&
        this.selectedBank &&
        this.withdrawAmount &&
        Number.isFinite(amt) &&
        amt > 0 &&
        (this.minTransactionUSD ? amt >= this.minTransactionUSD : true) &&
        (!this.selectedAccountDetails ||
          this.currencyAmount <= this.selectedAccountDetails.availableMarginFree)
      );
    },
  },

  watch: {
    withdrawAmount(newAmount) {
      if (this.currency && this.currency.rate) {
        this.currencyAmount = (newAmount * this.currency.rate).toFixed(2);
      } else {
        this.currencyAmount = newAmount;
      }
    },

    // ✅ if methods/payment_id changes, re-pick min_transaction
    methods: {
      handler() {
        this.pickMinTransactionFromMethods();
      },
      immediate: true,
    },
    payment_id() {
      this.pickMinTransactionFromMethods();
    },
  },

  methods: {
    ...mapActions("withdraw", [
      WITHDRAWMETHODS__ACTIONS.WITHDRAWACCOUNTS,
      WITHDRAWMETHODS__ACTIONS.WITHDRAWMETHODS,
      WITHDRAWMETHODS__ACTIONS.BROKERSBANK,
      WITHDRAWMETHODS__ACTIONS.CREATEBANKWITHDRAW,
      //WITHDRAWMETHODS__ACTIONS.WITHDRAWOTP,
    ]),

    //  get min_transaction from store "methods" payload
    // Adjust field names here based on your API response shape.
    pickMinTransactionFromMethods() {
      try {
        if (!this.payment_id || !Array.isArray(this.methods)) return;

        const method =
          this.methods.find(
            (m) =>
              String(m.id) === String(this.payment_id) ||
              String(m.payment_id) === String(this.payment_id)
          ) || null;

        const min =
          method?.payment_settings?.min_transaction ??
          method?.min_transaction ??
          method?.minTransaction ??
          0;

        this.minTransactionUSD = Number(min) || 0;
      } catch (e) {
        this.minTransactionUSD = 0;
      }
    },

    handleAccountChange() {
      this.withdrawAmount = "";
      this.errors.account = false;
      this.currencyAmount = "";

      const account_details = this.accounts.find(
        (acc) => acc.trading_account_no === this.selectedAccount
      );

      if (account_details) {
        this.currency.rate = account_details.currency_rate;
        this.currency.name = account_details.currency_name;
        this.currency.symbol = account_details.currency_symbol;
        this.currency.color = account_details.symbol_color;
      }
    },

    handleBankChange() {
      const selectedBank = this.banks.find((b) => b.id === this.selectedBank);
      if (selectedBank) {
        this.bankAccountNumber = selectedBank.bank_acc_num;
        this.bankAccountName = selectedBank.bank_acc_name;
        this.bankSwiftNum = selectedBank.ifsc_code;
        this.bankCountry = selectedBank.bank_country;
        this.bankCity = selectedBank.city_country;
        this.bankAddress = selectedBank.bank_address;
      }
      this.errors.bank = false;
    },

    validateForm() {
      const amt = parseFloat(this.withdrawAmount);

      this.errors.account = !this.selectedAccount;
      this.errors.bank = !this.selectedBank;

      // minTransactionUSD check
      this.errors.amount =
        !this.withdrawAmount ||
        !Number.isFinite(amt) ||
        amt <= 0 ||
        (this.minTransactionUSD ? amt < this.minTransactionUSD : false);

      return !this.errors.account && !this.errors.bank && !this.errors.amount;
    },

    async handleSubmit() {
      if (!this.validateForm()) {
        const amt = parseFloat(this.withdrawAmount);
        if (this.minTransactionUSD && Number.isFinite(amt) && amt < this.minTransactionUSD) {
          toast.error(`Minimum withdrawal is $${this.minTransactionUSD}`);
        } else {
          toast.error("Please fill all required fields correctly");
        }
        return;
      }

      this.loading = true;
      try {

        const withdrawalData = {
          trading_account_no: this.selectedAccount,
          amount: this.withdrawAmount,
          bank_id: this.selectedBank,
          payment_id: this.payment_id,
        };

        const res = await this[WITHDRAWMETHODS__ACTIONS.CREATEBANKWITHDRAW](withdrawalData);
        if(res === true){
          this.resetForm();
        }
        
      } catch (error) {
        toast.error(error.message || "Failed to process withdrawal");
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.selectedAccount = null;
      this.selectedBank = null;
      this.bankAccountNumber = "";
      this.bankAccountName = "";
      this.bankSwiftNum = "";
      this.bankCountry = "";
      this.bankCity = "";
      this.bankAddress = "";
      this.withdrawAmount = "";
      this.errors = {
        account: false,
        bank: false,
        amount: false,
      };
    },
  },

  async mounted() {
    this.payment_id = this.$route.query.payment_id;

    await this[WITHDRAWMETHODS__ACTIONS.WITHDRAWMETHODS]();
    await this[WITHDRAWMETHODS__ACTIONS.WITHDRAWACCOUNTS]();
    await this[WITHDRAWMETHODS__ACTIONS.BROKERSBANK]();

    // minTransactionUSD after methods load
    this.pickMinTransactionFromMethods();
  },
};
</script>

<style lang="scss" scoped>
.bank-withdraw-page {
  --withdraw-page: #f7f8fa; --withdraw-panel: #fff; --withdraw-field: #fff; --withdraw-border: #dfe2e6;
  --withdraw-text: #171a1f; --withdraw-muted: #626973; --withdraw-gold: #d99a00;
  box-sizing: border-box; height: calc(100vh - 64px); min-height: 100%; overflow-x: hidden; overflow-y: auto;
  color: var(--withdraw-text); background: var(--withdraw-page); overscroll-behavior-y: contain; -webkit-overflow-scrolling: touch;
}
.bank-withdraw-page--dark {
  --withdraw-page: #030b13; --withdraw-panel: #07111b; --withdraw-field: #08131e; --withdraw-border: #293026;
  --withdraw-text: #f4f5f7; --withdraw-muted: #aeb6c0; --withdraw-gold: #ffc400;
  background: radial-gradient(circle at 70% 14%, rgba(255, 196, 0, .05), transparent 34%), var(--withdraw-page);
}
.bank-withdraw-container { box-sizing: border-box; max-width: none !important; min-height: 100%; padding: 16px 18px 24px !important; }
.bank-withdraw-heading { min-height: 64px; display: flex; align-items: center; gap: 13px; margin-bottom: 8px; }
.bank-withdraw-heading > span { width: 42px; height: 42px; display: inline-flex; align-items: center; justify-content: center; color: var(--withdraw-gold); border: 1px solid rgba(217, 154, 0, .42); border-radius: 9px; background: rgba(217, 154, 0, .09); }
.bank-withdraw-heading .v-icon { color: inherit; }
.bank-withdraw-heading h1 { margin: 0 0 3px; color: var(--withdraw-text); font-size: 23px; line-height: 1.2; }
.bank-withdraw-heading p { margin: 0; color: var(--withdraw-muted); font-size: 13px; }
.bank-withdraw-form-card, .bank-withdraw-summary { color: var(--withdraw-text) !important; border: 1px solid var(--withdraw-border); border-radius: 10px !important; background: var(--withdraw-panel) !important; box-shadow: none !important; }
.bank-withdraw-form-card { padding: 12px 14px; }
/* Keep existing control dimensions and fieldset layout; change theme colors only. */
.bank-withdraw-page .deposit-form fieldset { border-color: var(--withdraw-border) !important; background: var(--withdraw-field) !important; }
.bank-withdraw-page .deposit-form fieldset legend { color: var(--withdraw-text) !important; background: var(--withdraw-panel) !important; }
.bank-withdraw-page::v-deep .deposit-form fieldset .custom-select .v-input__slot { border-color: transparent !important; background: var(--withdraw-field) !important; }
.bank-withdraw-page::v-deep .deposit-form fieldset .custom-select input,
.bank-withdraw-page::v-deep .deposit-form fieldset .custom-select .v-select__selection { color: var(--withdraw-text) !important; }
.bank-withdraw-page::v-deep .deposit-form fieldset .custom-select .v-label,
.bank-withdraw-page::v-deep .deposit-form fieldset .custom-select input::placeholder { color: var(--withdraw-muted) !important; opacity: .78; }
.bank-withdraw-page::v-deep .deposit-form fieldset .custom-select .v-icon { color: var(--withdraw-gold) !important; }
.bank-withdraw-page legend small { color: var(--withdraw-gold) !important; }
.bank-withdraw-button { width: 100%; height: 44px !important; color: #17130a !important; border-radius: 6px !important; background: linear-gradient(135deg, #ffd43b, #ffc400) !important; font-weight: 700; }
.bank-withdraw-summary { overflow: hidden; }
.bank-withdraw-summary > .v-card__actions { min-height: 58px; padding: 12px 16px; border-bottom: 1px solid var(--withdraw-border); }
.bank-withdraw-summary > .v-card__actions:last-child { border-bottom: 0; }
.trade-status { display: flex; align-items: center; gap: 11px; }
.trade-status > div:first-child { width: 39px; height: 39px; display: inline-flex; align-items: center; justify-content: center; border-radius: 7px; background: rgba(217, 154, 0, .1); }
.trade-status .v-icon { color: var(--withdraw-gold) !important; }
.trade-number, .value-trades, .currency-leverage, .balance-equity { display: flex; flex-direction: column; gap: 3px; }
.trade-number span:first-child, .value-trades span:last-child, .currency-leverage span:last-child, .balance-equity span:last-child { color: var(--withdraw-text); font-weight: 600; }
.trade-number span:last-child, .value-trades span:first-child, .currency-leverage span:first-child, .balance-equity span:first-child { color: var(--withdraw-muted); font-size: 11px; }
.bank-withdraw-summary::v-deep .v-alert { color: var(--withdraw-muted) !important; border-color: rgba(217, 154, 0, .3) !important; background: rgba(217, 154, 0, .06) !important; }
.bank-withdraw-summary::v-deep .v-alert .v-icon { color: var(--withdraw-gold) !important; }
@media (max-width: 760px) {
  .bank-withdraw-page { height: calc(100vh - 56px); height: calc(100dvh - 56px); }
  .bank-withdraw-container { padding: 12px 10px 20px !important; }
  .bank-withdraw-container > .row { margin-right: -6px; margin-left: -6px; }
  .bank-withdraw-container > .row > [class*="col-"] { width: 100%; max-width: 100%; flex: 0 0 100%; padding: 6px; }
  .bank-withdraw-heading p { display: none; }
  .bank-withdraw-heading h1 { font-size: 21px; }
  .bank-withdraw-form-card { padding: 7px; }
  .bank-withdraw-form-card > .row { margin-right: -6px; margin-left: -6px; }
  .bank-withdraw-form-card > .row > [class*="col-"] { padding: 6px; }
  .bank-withdraw-button { width: 100%; }
  .bank-withdraw-summary { margin-top: 6px !important; }
}
@media (max-width: 380px) {
  .bank-withdraw-heading > span { width: 38px; height: 38px; }
  .bank-withdraw-heading h1 { font-size: 19px; }
}
</style>
